import {
  CLOUD_SOURCE_UNAVAILABLE_REASON,
  DROPBOX_UNCONFIGURED_REASON,
  EASY_MODE_CLOUD_SOURCE,
  EASY_MODE_CLOUD_SOURCES
} from '../constants/easyModeIntegrations';
import useEasyModeDropboxImport from './useEasyModeDropboxImport';

// Builds the drop zone's import button row so the panel itself stays dumb. Dropbox is the only
// provider with a picker; OneDrive stays disabled with the reason why.
const useEasyModeCloudSources = ({ onFilesReady }) => {
  const dropbox = useEasyModeDropboxImport({ onFilesReady });

  return EASY_MODE_CLOUD_SOURCES.map((source) => {
    if (source.value !== EASY_MODE_CLOUD_SOURCE.DROPBOX) {
      return {
        ...source,
        label: source.text,
        isAvailable: false,
        isDisabled: true,
        unavailableReason: CLOUD_SOURCE_UNAVAILABLE_REASON,
        onClick: null
      };
    }

    return {
      ...source,
      label: dropbox.isImporting ? 'Importing...' : source.text,
      isAvailable: dropbox.isEnabled,
      // the chooser script loads on mount, so the button waits rather than opening nothing
      isDisabled: !dropbox.isEnabled || !dropbox.isReady || dropbox.isImporting,
      unavailableReason: DROPBOX_UNCONFIGURED_REASON,
      onClick: dropbox.openPicker
    };
  });
};

export default useEasyModeCloudSources;
